<template>
  <div class="subscription-page">
    <choose-plan v-if="step === 0" :selected="priceId" @selected="selectedPrice"></choose-plan>
    <add-card-step @submit="submit" :priceId="priceId" v-if="step === 1"></add-card-step>
    <!-- <congrat v-if="step === 2"></congrat> -->
  </div>
</template>

<script>
import choosePlan from '@/components/subscription/choosePlan';
import addCardStep from '@/components/subscription/addCardStep';
// import congrat from '@/components/subscription/congrat';
import manageSubscriptionStatus from '@/utils/manageSubscription';

export default {
  name: 'Subscription',

  data () {
    return {
      step: 0,
      priceId: null,
      afterSubmit: false,
    };
  },

  components: {
    choosePlan,
    addCardStep,
    // congrat,
  },

  computed: {
    user () {
      return this.$store.state.user.data.data;
    },

    isSubscribed () {
      return this.user.isSubscribed && this.user.subscription;
    },
  },

  watch: {
    isSubscribed: {
      handler: function () {
        if (this.isSubscribed && !this.afterSubmit) {
          return this.$router.replace(this.$i18nRoute({ name: 'settings' }));
        }
      },
      immediate: true,
    },

    '$route.query.step' () {
      if (this.step !== this.$route.query.step) {
        this.step = +this.$route.query.step;
      }

      if (this.step === 2 && this.isSubscribed) {
        return this.$router.replace(this.$i18nRoute({ name: 'onboardingSpecial' }));
      }
    },
  },

  methods: {
    changeStep () {
      this.step++;
      this.$router.push(this.$i18nRoute({ ...this.$route, query: { step: this.step } })).catch(() => {});
      this.afterSubmit = false;
    },

    selectedPrice (priceId) {
      this.priceId = priceId;
      this.changeStep();
    },

    async submit ({ token, cb }) {
      this.afterSubmit = true;
      try {
        const purchaseData = await this.$store.dispatch({
          type: 'user/PURCHASE',
          data: { token: token, priceId: this.priceId, language: this.$route.params.locale },
        });

        await manageSubscriptionStatus(purchaseData.data.subscription);
        cb();

        if (purchaseData.data.isSubscribed) {
          this.changeStep();
          const plan = purchaseData.data.subscription.plan;
          let productScu = '';

          switch (plan.productName) {
          case '1 month':
            productScu = 'Monthly Plan Trial';
            break;
          case '6 months':
            productScu = '6 Month Plan Trial';
            break;
          case '12 months':
            productScu = '12 Month Plan Trial';
            break;

          default:
            productScu = plan.productName;
            break;
          }
          window.dataLayer && window.dataLayer.push({
            event: 'transactionComplete',
            transactionId: this.user ? `${this.user.email}/${new Date().getTime()}` : `noUser/${new Date().getTime()}`,
            transactionTotal: 1,
            transactionProducts: [{
              sku: productScu,
              name: productScu,
              price: 1,
              quantity: 1,
            }],
          });
        }
      } catch (error) {
        cb();
      }
    },
  },

  created () {
    if (!this.$route.query.step && !this.isSubscribed) {
      this.$router.replace(this.$i18nRoute({ ...this.$route, query: { step: this.step } }));
    }
  },
};
</script>

<style lang="scss" scoped>
.subscription-page {
  background-image: url('~@/static/custom-img/congrat_bg.png');
  background-size: contain;
  background-position-y: 30px;
}
</style>
